// Le match nommé en entier dans les alertes FFBB (D-117) : groupe, équipe engagée, adversaire (« à » : à l'extérieur,
// « – » : à domicile), jour et heure. Le même texte que la base (_match_label, à l'heure du club) :
// « Seniors filles · SF2 à Lusmagne · sam. 17 oct. 13h », « U13 filles – Crestavel · dim. 8 nov. 10h ».

const DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
const MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

/** « sam. 17 oct. 13h », « dim. 1er nov. 20h30 » (heure de l'appareil). */
export function whenShort(d: Date): string {
  const day = d.getDate();
  const min = d.getMinutes();
  return `${DAYS[d.getDay()]} ${day}${day === 1 ? 'er' : ''} ${MONTHS[d.getMonth()]} ${d.getHours()}h${min ? String(min).padStart(2, '0') : ''}`;
}

export interface MatchLabelInput { group: string; squad?: string | null; opponent: string; isHome: boolean | null; start: Date }

/** Groupe et équipe engagée, sans le jour : « Seniors filles · SF2 à Lusmagne ». */
export function matchName(m: Omit<MatchLabelInput, 'start'>): string {
  return `${m.group}${m.squad ? ` · ${m.squad}` : ''}${m.isHome === false ? ' à ' : ' – '}${m.opponent}`;
}

/** Le match en entier : « Seniors filles · SF2 à Lusmagne · sam. 17 oct. 13h ». */
export function matchLabel(m: MatchLabelInput): string {
  return `${matchName(m)} · ${whenShort(m.start)}`;
}
